module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "px-5 pt-5 mt-5 text-poppins-36"
  }, [_vm._v("Upload product")]), _vm._v(" "), (!_vm.product.image1) ? _c('div', [_c('div', {
    staticClass: "page-content mx-5"
  }, [_c('drag-file-uploader', {
    ref: "dragFileUploader",
    attrs: {
      "accept": "image/*",
      "type": "image",
      "category": "product",
      "autoUpload": true
    },
    on: {
      "filePicked": _vm.pickedFile
    }
  })], 1)]) : _c('div', [(_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "page upload-child sell-page product-page mx-5"
  }, [(!_vm.currentUser.stripe_connected) ? _c('topbarNotification', {
    attrs: {
      "content": _vm.topBarContent,
      "ctaTitle": "Connect",
      "cta": {
        name: 'ManageIndex',
        params: {
          tab: 'payment'
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.isPageReady) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "my-2 album-info-title"
  }, [_vm._v("Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Product Name\n                        ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Category\n                        ")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.product_categories,
      "item-text": "name",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": ""
    },
    on: {
      "change": _vm.onChangeProductCategory
    },
    model: {
      value: (_vm.product.category),
      callback: function($$v) {
        _vm.$set(_vm.product, "category", $$v)
      },
      expression: "product.category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Description\n                        ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    staticClass: "product-description form-control non-resizable",
    attrs: {
      "maxlength": "2000"
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg5": "",
      "pl-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Product Images\n                      ")])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": "",
      "mt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image1) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image1"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image1) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image1) ? _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image1) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image1')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image2) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image2"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image2) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image2) ? _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image2) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image2')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image3) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image3"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image3) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image3) ? _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image3) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image3')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image4) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image3"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image4) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file4",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image4', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image4) ? _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image4) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image4')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [(!_vm.isDigitalProduct) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Tax")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": "",
      "product-section": "",
      "mt-4": ""
    }
  }, [_c('v-checkbox', {
    on: {
      "change": _vm.resetTaxPercent
    },
    model: {
      value: (_vm.product.is_vat),
      callback: function($$v) {
        _vm.$set(_vm.product, "is_vat", $$v)
      },
      expression: "product.is_vat"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Sellers outside of US check box for VAT/GST\n                          ")])])], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "mt-3": ""
    }
  }, [(_vm.product.is_vat) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers Country")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers State")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "CA",
      "items": _vm.states,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [(_vm.product.is_vat) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                          Tax\n                        ")]) : _c('label', {
    staticClass: "control-label"
  }, [_vm._v("State Tax")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control primary-input",
    attrs: {
      "currency": "%",
      "placeholder": "8.5%",
      "currency-symbol-position": "suffix",
      "separator": ",",
      "precision": 3,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.product.tax_percent),
      callback: function($$v) {
        _vm.$set(_vm.product, "tax_percent", $$v)
      },
      expression: "product.tax_percent"
    }
  })], 1)], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "section-title": ""
    }
  }, [_c('h4', [_vm._v("Digital Product Upload")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('h4', {
    staticClass: "option-title"
  }, [_vm._v(".Zip file only, 2GB max upload")]), _vm._v(" "), _c('digital-uploader', {
    attrs: {
      "digitalContent": _vm.digital_content
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Collaborators")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "collaborator-section first-child",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title-x mt-3"
  }, [_c('span', {
    staticClass: "my-2 mr-2"
  }, [_vm._v("\n                        Collaborators (" + _vm._s(_vm.product.collaborators.length) + ")\n                      ")]), _vm._v(" "), (_vm.product.collaborators.length < 3) ? _c('v-btn', {
    staticClass: "add-option-btn",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "py-0": ""
    }
  }, [(
    _vm.product.collaborators &&
    _vm.product.collaborators.length > 0
  ) ? _c('v-layout', {
    attrs: {
      "row": "",
      "creator-wrapper": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('label', {
    staticClass: "creator-name"
  }, [_vm._v(_vm._s(_vm.$store.state.auth.user.username))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Profit split")]), _vm._v(" "), _c('label', {
    staticClass: "creator-share"
  }, [_vm._v(_vm._s(_vm.creator_share))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
    staticClass: "dflex align-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.creator_recoup_cost),
      expression: "product.creator_recoup_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.creator_recoup_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "creator_recoup_cost", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        _vm.deleteCollaborator(_vm.index)
      }
    }
  }, [_vm._v("clear")])], 1)])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.collaborators), function(collaborator, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "collaborator-wrapper": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborators")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.users,
        "item-text": "username",
        "item-value": "id",
        "chips": "",
        "autocomplete": "",
        "no-data-text": "No collaborator available",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                                " + _vm._s(data.item.username) + "\n                              ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.profit_share_types,
        "item-text": "name",
        "item-value": "id",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_share),
        callback: function($$v) {
          _vm.$set(collaborator, "user_share", $$v)
        },
        expression: "collaborator.user_share"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-15"
    }, [_vm._v("\n                                clear\n                              ")])], 1)])], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title mb-0"
  }, [_vm._v("Options")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg6": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Available to..\n                      ")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('div', {
          staticClass: "custom-multi-select"
        }, [_c('span', [_vm._v(_vm._s(data.item.title))]), _vm._v(" "), _c('v-icon', {
          staticClass: "icon-close text-white"
        }, [_vm._v("\n                            close\n                          ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.product.access_level),
      callback: function($$v) {
        _vm.$set(_vm.product, "access_level", $$v)
      },
      expression: "product.access_level"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "submit-section": "",
      "mt-5": ""
    }
  }, [_c('v-btn', {
    staticClass: "product-save-btn",
    class: {
      'app-blue': _vm.isAvailableToAddProduct,
      'cursor-pointer': !_vm.isAvailableToAddProduct,
    },
    attrs: {
      "disabled": !_vm.isAvailableToAddProduct
    },
    nativeOn: {
      "click": function($event) {
        _vm.beforeSaveProduct()
      }
    }
  }, [_vm._v("Release")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.collaborators_confirm_dialog),
      callback: function($$v) {
        _vm.collaborators_confirm_dialog = $$v
      },
      expression: "collaborators_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n              Confirm Collaborators\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Make sure to add any collaborators to your product, once it's\n              uploaded you won't be able to add collaborators.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "green",
      "dark": "",
      "block": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveProduct()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideCollaboratorsConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8a6f3f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sell/add_product.vue
// module id = 1768
// module chunks = 180